import styled, { css } from 'styled-components';

import { List, mediaMixin, spaceMixin } from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

export const StyledList = styled(List)`
  font-size: 12px;
  padding-left: 16px;
`;

export const StyledHR = styled(HR)`
  && {
    margin-top: ${spaceMixin('sm')};
    margin-bottom: ${spaceMixin('sm')};
  }
`;

export const StyledHidden = styled.div`
  ${(props: { breakpoint: string }) => {
    return mediaMixin(
      props.breakpoint,
      css`
        display: none;
      `,
    );
  }}
`;
